module.exports = __webpack_public_path__ + "static/media/email-placeholder.2445c42a.svg";